import React, { useRef } from "react";
import cx from "classnames";
import { Checkbox } from "./checkbox";
import { InputLabel } from "../inputLabel";
import { Radio } from "../../icons";
import { useRandomId } from "../../../hooks/useRandomId";
import { emptyFunction } from "../../../utils/helpers/emptyFunction";

const createAccessibleTitle = (title, hasDescription) => {
  if (!!title) {
    return title + (hasDescription ? " has further details" : "");
  }

  return title;
};

export const CustomCheckbox = React.forwardRef((props, ref) => {
  const { value, title, name, hideErrors, children, changeTitleColor } = props;
  const fallbackRef = useRef();
  const checkboxRef = ref ?? fallbackRef;
  const randomId = useRandomId();

  const checked = !!value;

  const onClick = () => {
    (checkboxRef.current || { click: emptyFunction }).click();
  };

  return (
    <Checkbox {...props} ref={checkboxRef} hidden ariaLabelledby={randomId} hideErrors={hideErrors}>
      <Radio ariaLive="polite" checked={checked} onClick={onClick} role="checkbox" aria-details="checkbox-details"
             aria-checked={checked} aria-labelledby={randomId} />
      <InputLabel id={randomId} name={name} onClick={() => {
        onClick();
      }} accessibleLabel={createAccessibleTitle(title, !!children)}>
        <span className={cx({'is-active': changeTitleColor }, 'checkbox-title')} >{title}</span>
        {children}
      </InputLabel>
    </Checkbox>
  );
});